// material-ui
import { Typography } from '@mui/material';
import { useSelector } from 'react-redux';

// project imports
import NavGroup from './NavGroup';
import menuItem from 'menu-items';
import { hasPermission } from 'utils/permission.util';

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
    const user = useSelector((state) => state.user.v_user_info);

    const filteredItems = menuItem.items
        .map((item) => ({
            ...item,
            children: item.children?.filter((child) => hasPermission(child.permission, user)),
        }))
        .filter((item) => item.children?.length);

    const navItems = filteredItems.map((item) => {
        switch (item.type) {
            case 'group':
                return <NavGroup key={item.id} item={item} />;
            default:
                return (
                    <Typography key={item.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    return <>{navItems}</>;
};

export default MenuList;
